import React from "react";
import { Chip } from "@mui/material";
import { PASTEL } from "./livechatTheme";
import { ASSIGNMENT_REASON_SPECIALIST } from "./livechatConstants";

const chipSx = { height: 18, fontSize: 10, fontWeight: 700, "& .MuiChip-label": { px: 0.75 } };

/**
 * DEV-1234 — penanda kepemilikan di item percakapan. Sesi brand non-auto-assign (corporate, mitra)
 * tidak pernah punya assignedAgentId dan `isAutoAssignBrand` false, jadi tidak merender apa pun.
 * - "Baru ditugaskan": milik saya & belum dibaca
 * - "Unassigned": brand auto-assign yang belum ada pemiliknya
 * DEV-1238 — + "Spesialis produk" kalau sesi ditugaskan karena spesialisasi produk sales (AC-6).
 * MTN-956 — berlaku juga di brand non-auto-assign (Order / EP Point) untuk:
 * - "Pesan baru setelah selesai" (khusus Tim CS, `showAwaitingCs`): customer membalas chat Paid
 *   yang sudah Selesai dan belum dicek Tim CS
 * - "Dialihkan oleh <CS>": chat hasil Alihkan Chat, menggantikan "Baru ditugaskan"
 */
export default function AssignmentBadge({ session, viewerId, isAutoAssignBrand, showAwaitingCs = false }) {
    const awaitingChip = showAwaitingCs && session.awaitingCsSince && (
        <Chip size="small" label="Pesan baru setelah selesai" sx={{ ...chipSx, backgroundColor: "#fde4e4", color: "#c62828" }} />
    );

    const ownerId = session.assignedAgentId;
    const isMine = ownerId != null && Number(ownerId) === Number(viewerId);
    const transferChip = session.lastTransfer && (
        <Chip
            size="small"
            label={`Dialihkan oleh ${session.lastTransfer.byAgentName || "Tim CS"}`}
            sx={isMine && session.unreadByAgent
                ? { ...chipSx, backgroundColor: PASTEL.primary, color: "#fff" }
                : { ...chipSx, backgroundColor: PASTEL.primarySoft, color: PASTEL.primary }}
        />
    );

    if (!isAutoAssignBrand) {
        return awaitingChip || transferChip ? <>{awaitingChip}{transferChip}</> : null;
    }

    if (ownerId == null) {
        return (
            <>
                <Chip size="small" label="Unassigned" variant="outlined" sx={{ ...chipSx, color: "text.secondary", borderColor: PASTEL.border }} />
                {awaitingChip}
            </>
        );
    }

    const specialistChip = session.assignmentReason === ASSIGNMENT_REASON_SPECIALIST && (
        <Chip
            size="small"
            label="Spesialis produk"
            title={session.leadProduct ? `Ditugaskan ke spesialis ${session.leadProduct}` : undefined}
            sx={{ ...chipSx, backgroundColor: "#fff4d6", color: "#9a6a00" }}
        />
    );

    if (transferChip) {
        return <>{transferChip}{awaitingChip}</>;
    }

    if (isMine && session.unreadByAgent) {
        return (
            <>
                <Chip size="small" label="Baru ditugaskan" sx={{ ...chipSx, backgroundColor: PASTEL.primary, color: "#fff" }} />
                {specialistChip}
                {awaitingChip}
            </>
        );
    }

    // Nama pemilik tidak lagi di-chip di sini — ditampilkan di baris pemilik `ConversationList`.
    return specialistChip || awaitingChip ? <>{specialistChip}{awaitingChip}</> : null;
}
